import { useProduct } from "../../context/ProductContext";

export function ProductFlipToggle({ className = "" }) {
  const { product, setProduct, isFlipping } = useProduct();
  const isVault = product === "biorvault";

  return (
    <div
      className={`product-flip ${className}`}
      role="tablist"
      aria-label="Switch product"
      data-testid="product-flip-toggle"
    >
      <span
        className="product-flip__thumb"
        aria-hidden="true"
        data-state={isVault ? "vault" : "swap"}
      />
      <button
        type="button"
        role="tab"
        aria-selected={isVault}
        data-testid="flip-to-biorvault"
        className={`product-flip__btn ${isVault ? "product-flip__btn--active" : ""}`}
        onClick={() => setProduct("biorvault")}
        disabled={isFlipping}
      >
        <span className="product-flip__dot product-flip__dot--vault" aria-hidden="true" />
        BiorVault
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={!isVault}
        data-testid="flip-to-biorswap"
        className={`product-flip__btn ${!isVault ? "product-flip__btn--active" : ""}`}
        onClick={() => setProduct("biorswap")}
        disabled={isFlipping}
      >
        <span className="product-flip__dot product-flip__dot--swap" aria-hidden="true" />
        BiorSwap
      </button>
    </div>
  );
}

export default ProductFlipToggle;
